import { AbstractControl } from '@angular/forms';
import moment from 'moment';

export class BcValidators {
    static bcDateStringValidator(control: AbstractControl): { [key: string]: any } | null {
        if (!control.value) {
            return null;
        }

        const dateString: string = control.value;
        if (dateString) {
            const valid = /\d{2}\/\d{2}\/\d{4}/g.test(dateString);
            if (valid && moment(dateString, 'MM/DD/YYYY', true).isValid()) {
                return null;
            }
        }

        return { invalidDate: { value: control.value } };
    }
}
